import { B1, BottomSheet, H6, Icon, Stack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'

import { ICON_MAP } from '../../../utils/iconMap'

type AccountAggregratorBottomSheetProps = {
  isVisible: boolean
  closeBottomSheet: () => void
}
const AccountAggregratorBottomSheet = ({
  isVisible,
  closeBottomSheet,
}: AccountAggregratorBottomSheetProps) => {
  return (
    <BottomSheet
      visible={isVisible}
      disableBottomSheet={closeBottomSheet}
      sheetName="add_customer_employment_details_occupation"
      snapPoints={[DEVICE_HEIGHT - 300, 500]}
    >
      <Pressable onPress={closeBottomSheet} className="mr-2 items-end">
        <Icon size={24} type="Close" />
      </Pressable>
      <Stack className="items-center">
        <ICON_MAP.AGGREGATOR_ICON />
        <H6>What is an Account Aggregator?</H6>
        <Stack className="px-3 pb-4 pt-3">
          <B1>• Account Aggregator (AA) is an entity regulated by RBI.</B1>
          <B1>
            • It facilitates secure financial data sharing between two financial
            institutions. The entire process of data sharing is digital and
            takes place in near real-time. The AAs cannot read your data,
            neither store them.
          </B1>
          <B1>
            • They simply facilitate the transfer of data between two financial
            institutions (e.g., Availing of a personal loan with HDFC Bank by
            sharing your bank statement of a non-HDFC Bank via Account
            Aggregator)
          </B1>
          <B1>
            • They simply facilitate the transfer of data between two financial
            institutions (e.g., Availing of a personal loan with HDFC Bank by
            sharing your bank statement of a non-HDFC Bank via Account
            Aggregator)
          </B1>
        </Stack>
      </Stack>
    </BottomSheet>
  )
}

export default AccountAggregratorBottomSheet
